import { useQuery } from '@tanstack/react-query';
import { ChatApi } from 'api/ApiHelper';
import { chatQueryKey } from 'queries/chat/queryKey';

export const useGetUnreadChatMessageCount = (enabled = false) =>
  useQuery({
    queryKey: chatQueryKey.unread,
    queryFn: () => ChatApi.getUnreadCount(),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 50,
    refetchInterval: 1000 * 60 * 30,
    enabled,
  });
